import { LitElement, html, css } from 'lit';
import { EventManager } from '../../utilities/events';
import { decodeEntities } from '../../utilities/formsUtilities';
export class AllInBreadcrumb extends LitElement {
    static properties = {
        crumb: { type: Array },
        name: { type: String },
        _initialCrumb: { state: true,type: Array },
    }

    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        this._initialCrumb = [...this.crumb];
        this.eventManager.listen(`allin-breadcrumb-${this.name}`,this._handleBreadcrumbChange);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }

    _handleBreadcrumbChange(e){
       /*  if(e.detail.reset=='reset'){
            this.crumb = [...this._initialCrumb];
        }
        if(e.detail.back){
            for(let i=0;i<e.detail.back;i++){
                this.crumb.pop();
            }
        }
        if(e.detail.crumb){
            // OLD - CAUSED CRUMB BRANCH REPETITION
            // this.crumb = [...this.crumb,e.detail.crumb];

            // NEW - RESOLVES THE REPETITION ISSUE
            const newCrumb = e.detail.crumb;

            // Check if last crumb is the same
            const lastCrumb = this.crumb[this.crumb.length - 1];
            if (!lastCrumb || lastCrumb.title !== newCrumb.title || lastCrumb.url !== newCrumb.url) {

                // See if this crumb exists earlier in the trail
                const existingIndex = this.crumb.findIndex(c => c.url === newCrumb.url);
                if (existingIndex >= 0) {
                    // If yes, trim all breadcrumbs after it reset
                    this.crumb = this.crumb.slice(0, existingIndex + 1);
                } else {
                    // Else, append normally
                    this.crumb = [...this.crumb, newCrumb];
                }
            }
        } */
        
        if(!e.detail){
            this.crumb = [...this._initialCrumb];
            this.requestUpdate();
            return;
        }
        let listing = e.detail.listing;
        let organisation = e.detail.organisation;    
        let dashboard = e.detail.dashboard;
        let panel = e.detail.panel;
        let view = e.detail.view;
        let subview = e.detail.subview;
        this.crumb = [...this._initialCrumb];
        if(listing){
            if(panel){
                this.crumb.push(panel);
            }
        }
        if(organisation){
            this.crumb.push(organisation);
        }
        if(dashboard){
            this.crumb.push(dashboard);
            if(panel){
                this.crumb.push(panel);
                if(view){
                    this.crumb.push(view);
                    if(subview){
                        this.crumb.push(subview);
                    }
                }
            }
        }
        this.requestUpdate();
    }

    render() {
            let length = this.crumb.length;
            return html` 
                ${this.crumb.map((item,i)=>{
                    let current = '';
                    let aria = 'false';
                    if(length-1==i){
                        current='crumb--current'
                        // aria='current'
                        aria='page'
                    }
                    if(!item.hasOwnProperty('callback')){
                        item.callback = (e)=>{
                            return true;
                        }
                    }
                    return html`
                        <li class="crumb ${current}" aria-current="${aria}">
                            <a href="${item.url}" @click=${item.callback}>${decodeEntities(item.title)}</a>
                        </li>
                    `
                })}
            `
    }

  static styles = [
    css`
        :host {
            font-family:var(--allin-font-family,inherit);
            font-size:var(--allin-font-size,1rem);
            color:var(--allin-text-color,#472961);
            background-color:var(--allin-bg-color,transparent);
            padding:var(--allin-padding,0);
            display: flex;
            flex-direction: row;
            column-gap: 1rem;
            padding-right: 3rem;
            //flex-wrap:wrap;
        }
        a {
            text-decoration: none;
            color:var(--allin-text-color,#472961);;
            display: flex;
            align-items: center;
            white-space: nowrap;
        }
        .crumb {
            font-weight: var(--allin-font-weight,bold);
            font-size: var(--allin-crumb-font-size,0.85rem);
            display: flex;
            align-items: center;
        }
        .crumb--current {
            font-weight: var(--allin-font-weight--current,600);
            color: var(--allin-color,#1a1a1a);
            font-size: var(--allin-crumb-font-size,0.85rem);
            display: flex;
            align-items: center;
        }
        li.crumb::before {
            content: " > ";
            color: #9a9a9a;
            font-size: 1.5rem;
            position: relative;
            margin-right: 1rem;
            font-weight: 400;
        }
        li.crumb--current::before {
            content: " > ";
            color: #9a9a9a;
            font-size: 1.5rem;
            position: relative;
            margin-right: 1rem;
            font-weight: 400;
        }

    `];
}


